/**
 * V2 preview visibility gate — the master orchestration plan's
 * 2026-07-09 Amendment (verbatim). V2 surfaces (Home briefing, and later
 * the rest of the redesign) render ONLY when this returns true:
 *
 * - Dev builds (localhost): everyone, including brand test accounts.
 * - Prod builds: ADMIN/SUPER_ADMIN only, and only when the
 *   `VITE_V2_PREVIEW` build var is the exact string "true". The Railway
 *   var stays unset for now, so V2 is localhost-only; enabling an
 *   admin-only prod preview later is one env var, zero code changes.
 *
 * Brands can never reach V2 in prod — no nav entry (Sidebar) and typed
 * URLs bounce via `V2PreviewRoute` — until the sunset decision flips it.
 *
 * (The catalog flag lives in `lib/featureFlags.ts`; this module is the
 * V2-preview gate mandated at this path by the Amendment.)
 */
export function isV2PreviewEnabled(user: { role: string } | null): boolean {
  if (import.meta.env.DEV) return true; // localhost: everyone, incl. brand test accounts
  return (
    (user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') &&
    import.meta.env.VITE_V2_PREVIEW === 'true'
  );
}
